import debug from "bows/dist/bows.min.js";
import $ from "jquery";
import pagination from "./_test-lab-pagination";

// Make :contain case insensitive
jQuery.expr[":"].Contains = function (a, i, m) {
	return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) >= 0;
};

const endpoint = "/wp-json/ctia/v1/authorizedtestlabs";
const log = debug("test-labs");

let labs = "";
let testLab = document.getElementById("test-lab");
let capabilities_filter = document.getElementById("capabilities-filter");
let countries_filter = document.getElementById("countries-filter");
const ptcrb_filter = document.querySelector(".filter__dropdown--ptcrb");

let countries_array = [];
let countries = new Set();
let certifcations_array = [];
let certifcations = new Set();
let labsHtml = [];
let count = 0;

const $test_lab_filter = $("#test-lab-filter");
const $capabilities_filter = $("#capabilities-filter");
const $country_filter = $("#countries-filter");
const $test_lab_search = $("#test-lab-search");
let $lab = $(".lab");

const labsConfig = window.CTIA.config[0].labs;

function search_labs() {
	$test_lab_search.on("keyup", function () {
		let textVal = $(this).val();
		if (textVal.length >= 3) {
			$(".lab").addClass("lab--no-match");
			$(`.lab:Contains(${textVal})`).removeClass("lab--no-match");
		} else {
			$(".lab").removeClass("lab--no-match");
		}
		doFilter_labs(true);
	});
}

function labs_visible() {
	if ($(".lab:visible").length === 0) {
	}
}

function show_all_labs($lab) {
	$lab.removeClass(
		"lab--no-filtered lab--filtered lab--check-country lab--cap-check"
	);
}

function doFilter_labs(isSearching) {
	log("doing The FIlter");
	let $cap_checked = $capabilities_filter.find(
		'input[type="checkbox"]:checked'
	);
	let $country_checked = $country_filter.find(
		'input[type="checkbox"]:checked'
	);

	$(".lab").addClass("lab--no-filtered lab--cap-check lab--check-country");
	if (
		$cap_checked.length === 0 &&
		$country_checked.length === 0 &&
		isSearching !== true
	) {
		show_all_labs($lab);
	} else {
		if ($cap_checked.length === 0) {
			$(".lab--cap-check").removeClass("lab--cap-check");
		} else {
			$cap_checked.each(function () {
				let val = $(this).val();
				$(`.lab:Contains(${val})`).removeClass("lab--cap-check");
			});
		}

		if ($country_checked.length === 0) {
			$(".lab--check-country").removeClass("lab--check-country");
		} else {
			$country_checked.each(function () {
				let val = $(this).val();
				$(`.lab--check-country:Contains(${val})`).removeClass(
					"lab--check-country"
				);
			});
		}
	}

	$(".lab").each(function () {
		let $this = $(this);
		log($this);
		if (
			$this.hasClass("lab--cap-check") === false &&
			$this.hasClass("lab--check-country") === false &&
			$this.hasClass("lab--no-match") === false
		) {
			$this.removeClass("lab--no-filtered");
		}
	});

	// labs_visible();
	pagination.setVars();
	setTimeout(() => {
		pagination.showPagination();
	}, 100);
}

function filter_labs() {
	$test_lab_filter.on("change", 'input[type="checkbox"]', doFilter_labs);
}

function addCommas($string) {
	return $string.replace(/,/g, ", ");
}

function setCertifications(certs, labsConfig) {
	if (!certs) return "";

	const updatedCerts = certs
		.split(",")
		.map((label) => label.trim())
		.map((label) => {
			const updated = labsConfig[label] || label;
			certifcations_array.push(updated);
			return updated;
		})
		.join(", ");

	return updatedCerts;
}

function setCertificationsFilter() {
	if (!ptcrb_filter) {
		let sorted = certifcations_array.sort().reverse();

		sorted.forEach((cert) => {
			certifcations.add(cert);
		});

		if (capabilities_filter) {
			let filter__dropdown =
				capabilities_filter.querySelector(".filter__dropdown");
			let count = 0;
			certifcations.forEach((cert) => {

				if (cert !== "Associate Test Lab" && cert !== "Primary Test Lab") {
					return;
				}

				filter__dropdown.innerHTML += `<li class="filter__item"><input type="checkbox" id="capability_${count}" value="${cert}" /><label for="capability_${count}">${cert}</label></li>`;
				count++;
			});
		}
	}
}

function setCountriesFilter() {
	let sorted = countries_array.sort();
	sorted.forEach((country) => {
		countries.add(country);
	});

	if (countries_filter) {
		let filter__dropdown =
			countries_filter.querySelector(".filter__dropdown");
		let count = 0;
		countries.forEach((country) => {
			filter__dropdown.innerHTML += `<li class="filter__item"><input type="checkbox" id="country_${count}" value="${country}" /><label for="country_${count}">${country}</label></li>`;
			count++;
		});
	}
}

function renderLabs() {
	let isExpanded = true;
	labs.forEach((lab) => {
		countries_array.push(lab.countrydisplay);
		let lab_type = lab.certificationWebsiteTestingCapabilities.includes(
			"PTCRB Certification - Associate Test Lab"
		) ? "Associate Test Lab" : "Primary Test Lab";

		setCertifications(
			lab.certificationWebsiteTestingCapabilities,
			labsConfig
		);

		let address = `<p><strong>Address</strong>${lab.address1}<br>`;
		if (lab.address2) {
			address += `${lab.address2}<br>`;
		}
		if (lab.city || lab.state || lab.zipcode) {
			if (lab.city) {
				address += `${lab.city}`;
				if (lab.state) {
					address += ", ";
				} else {
					address += " ";
				}
			}
			if (lab.state) {
				address += `${lab.state} `;
			}

			if (lab.zipcode) {
				address += `${lab.zipcode}`;
			}
			address += "<br>";
		}
		address += `${lab.countrydisplay}</p>`;

		let the_id = `accordion_${count}`;
		let html = `
			<article class="js-wikit-accordion__item lab">
				<div class="js-wikit-accordion__wrap">
					<h3 class="js-wikit-accordion__heading">
						<button aria-expanded="false" class="js-wikit-accordion__trigger" aria-controls="${the_id}" id="${the_id}-id">
							<span class="js-wikit-accordion__icon" aria-hidden="true">
								<span class="js-wikit-accordion__icon__closed">+</span>
								<span class="js-wikit-accordion__icon__opened">-</span>
							</span>
							<span class="js-wikit-accordion__title">
								${lab.name}
							</span>
							<span class="lab__type">${lab_type}</span>
						</button>
					</h3>

					<div id="${the_id}" role="region" aria-labelledby="${the_id}-id" class="js-wikit-accordion__panel" hidden>

						<div class="js-wikit-accordion__panel-content">

							<div class="lab__flex">
								<div class="lab__column">
									<div class="lab__section">
										<p><strong>Contact</strong>${lab.contactname}</p>
									</div>
									<div class="lab__section">
										<p><strong>Phone</strong>${lab.contactphone}</p>
									</div>
								</div>
								<div class="lab__column">
									<div class="lab__section">
										<p><strong>Email</strong><a href="mailto:${lab.contactemail}">${lab.contactemail}</a></p>
									</div>
								</div>
								<div class="lab__column">
									<div class="lab__section">
										${address}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</article>
		`;
		labsHtml.push(html);
		count++;
	});

	showLabs();
	setCertificationsFilter();
	setCountriesFilter();

	$lab = $(".lab");
}

function openFirstTab() {
	setTimeout(() => {
		$lab.eq(0)
			.addClass("is-expanded")
			.find(".js-wikit-accordion__trigger")
			.attr("aria-expanded", "true");
		$lab.eq(0)
			.find(".js-wikit-accordion__panel")
			.addClass("js-wikit-accordion__panel--open")
			.removeAttr("hidden");
	}, 1000);
}

function showLabs() {
	labsHtml.forEach((lab) => {
		testLab.innerHTML += lab;
	});

	openFirstTab();
	pagination.setVars();
	pagination.showPagination();
}

function getLabs(callback) {
	let data_certifcations = testLab.dataset.certification;

	fetch(endpoint)
		.then((response) => response.json())
		.then((data) => {

			let filtered_labs = [];
			labs = data.data;
			labs.forEach((lab) => {

				if (
					lab.certificationWebsiteTestingCapabilities.includes(
						"PTCRB Certification - Associate Test Lab"
					) === true ||
					lab.certificationWebsiteTestingCapabilities.includes(
						"PTCRB Certification - Primary Test Lab"
					) === true
				) {
					filtered_labs.push(lab);
				}

			});

			labs = filtered_labs;

			if (typeof callback == "function") {
				callback();
			}
		});
}

export function initLabs() {
	if (testLab) {
		getLabs(renderLabs);
	}

	if ($test_lab_search.length) {
		search_labs();
	}

	if ($test_lab_filter.length) {
		filter_labs();
	}
}

if (testLab) {
	initLabs();
}
